import Pikaday from 'pikaday';

function parseDateAttr(attrValue, fallbackYear, fallbackMonth, fallbackDay) {
  if (attrValue) {
    const [year, month, day] = attrValue.split('-').map(Number);
    return new Date(year, month - 1, day);
  }
  return new Date(fallbackYear, fallbackMonth, fallbackDay);
}

export default function() {

  const dobFields = document.querySelectorAll('#zendesk_ticket_forms_value');

  if(!dobFields.length) return;

  let today = new Date();
  let dd = String(today.getDate()).padStart(2, '0');
  let mm = String(today.getMonth()).padStart(2, '0');
  let yyyy = today.getFullYear();
  
  let minYear = yyyy - 120;
  let maxYear = yyyy;

  dobFields.forEach((dobField) => {
    
    const minDateValue = parseDateAttr(
      dobField.getAttribute('data-min-date'),
      minYear, mm, dd
    );

    const maxDateValue = parseDateAttr(
      dobField.getAttribute('data-max-date'),
      maxYear, mm, dd
    );
    
    new Pikaday({
      field: dobField,
      format: 'YYYY MM DD',
      minDate: minDateValue,
      maxDate: maxDateValue,
      defaultDate : today,
      yearRange: 120,
      toString(date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}-${month}-${day}`; 
      },
    });
  });
  
}
